import styled from 'styled-components'
import { Type } from '../types'

export const BackgroundFormAdressUpdate = styled.div`
  ${(props: Type) => props.theme?.formAddressUpdate?.backgroundFormAdressUpdate};
`